<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form" v-loading="loading">
        <div class="role-table-box" v-for="(item, index) in permissionData" :key="item.menuId">
          <div class="list-table-1">
            <el-checkbox  @change="handleChange1($event, item, index)" v-model="item.isChecked">
              {{ item.menuName }}
            </el-checkbox>
          </div>
          <template v-if="item.children && item.children.length > 0">
            <div class="list-table-2">
              <div class="table-2-1" v-for="(item2, index2) in item.children" :key="item2.menuId">
                <div class="list-2-1">
                  <div class="list">
                    <div class="list-box">
                      <el-checkbox
                        @change="handleChange2($event, item2, index, index2)"
                        v-model="item2.isChecked">
                        {{ item2.menuName }}
                      </el-checkbox>
                    </div>
                  </div>
                  <div class="list2">
                    <template v-for="item3 in item2.permissions">
                      <el-checkbox
                        :key="item3.menuId"
                        @change="handleChange3($event, item3, index, index2)"
                        v-model="item3.isChecked">
                        {{ item3.menuName }}
                      </el-checkbox>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="list-table-2">
              <div class="table-2-1">
                <div class="list-2-1">
                  <div class="list">
                    <div class="list-box"></div>
                  </div>
                  <div class="list2">
                    <template v-for="item2 in item.permissions">
                      <el-checkbox
                        :key="item2.menuId"
                        @change="handleChange4($event, item2, index)"
                        v-model="item2.isChecked">
                        {{ item2.menuName }}
                      </el-checkbox>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import UploadFiles from "@/components/UploadFiles2.vue";
import { addInfo, editInfo, detailInfo, getPermission, setPermissions } from "./api";
import { validatePhone, validatePrice } from "@/utils/validate";
import { getAreaNext } from "@/views/commonApi";
import { setAreaTree } from "@/utils";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
    UploadFiles,
  },
  data() {
    return {
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "菜单权限",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.companyId = ""
          this.permissionData = []
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      loading: false,
      companyId: "",
      permissionData: []
    };
  },
  mounted() {},
  methods: {
    init(row) {
      this.companyId = row.companyId;
      this.getPermissionData(row.companyId);
      this.dialogObj.show = true;
    },
    getPermissionData(companyId) {
      this.loading = true
      getPermission(companyId).then((res) => {
        if (res.code === 200) {
          this.permissionData = res.data;
        }
      }).finally(()=>{
        this.loading = false
      });
    },
    handleChange1(e, item, index) {
      // 第二层全变化
      if (
        this.permissionData[index].children &&
        this.permissionData[index].children.length > 0
      ) {
        this.permissionData[index]?.children.forEach((item) => {
          item.isChecked = e;
          if (item.permissions && item.permissions.length > 0) {
            item.permissions.forEach((item2) => {
              item2.isChecked = e;
            });
          }
        });
      } else {
        if (
          this.permissionData[index].permissions &&
          this.permissionData[index].permissions.length > 0
        ) {
          this.permissionData[index].permissions.forEach((item2) => {
            item2.isChecked = e;
          });
        }
      }
    },
    handleChange2(e, item, index, index2) {
      let isAllChecked = false;
      this.permissionData[index].children.forEach((item) => {
        if (item.isChecked) {
          isAllChecked = true;
        }
      });
      if (
        this.permissionData[index].children[index2].permissions &&
        this.permissionData[index].children[index2].permissions.length > 0
      ) {
        this.permissionData[index].children[index2].permissions.forEach(
          (item2) => {
            item2.isChecked = e;
          }
        );
      }
      this.permissionData[index].isChecked = isAllChecked;
    },
    handleChange3(e, item, index, index2, index3) {
      let isAllChecked = false;
      this.permissionData[index].children[index2].permissions.forEach(
        (item) => {
          if (item.isChecked) {
            isAllChecked = true;
          }
        }
      );
      // this.permissionData[index].children[index2].isChecked = isAllChecked;
      // this.permissionData[index].isChecked = isAllChecked;
    },
    handleChange4(e, item2, index) {
      this.permissionData[index].isChecked = e;
    },
    getAllCheckedMenuId() {
      let menuIds = [];
      if (this.permissionData && this.permissionData.length > 0) {
        this.permissionData.forEach((item) => {
          if (item.isChecked) {
            menuIds.push(item.menuId);
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach((item2) => {
              if (item2.isChecked) {
                menuIds.push(item2.menuId);
              }
              if (item2.children && item2.children.length > 0) {
                item2.children.forEach((item3) => {
                  if (item3.isChecked) {
                    menuIds.push(item3.menuId);
                  }
                });
              }
              if (item2.permissions && item2.permissions.length > 0) {
                item2.permissions.forEach((item3) => {
                  if (item3.isChecked) {
                    menuIds.push(item3.menuId);
                  }
                });
              }
            });
          }
          if (item.permissions && item.permissions.length > 0) {
            item.permissions.forEach((item2) => {
              if (item2.isChecked) {
                menuIds.push(item2.menuId);
              }
            });
          }
        });
      }
      return menuIds;
    },
    // 提交数据
    submitForm() {
      this.dialogObj.btnLoading = true;
      const par = {
        "companyId": this.companyId,
        "menuIds": this.getAllCheckedMenuId()
      };
      setPermissions(par)
        .then((res) => {
          this.dialogObj.btnLoading = false;
          if (res.code === 200) {
            this.$message.success("设置成功");
            this.dialogObj.beforeClose();
          }
        })
        .catch((e) => {
          this.dialogObj.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  min-height: 200px;
  box-sizing: border-box;
  .role-table-box {
    display: flex;
    padding: 0.1rem 0;
    .list-table-1 {
      width: 25%;
      display: flex;
      align-items: center;
      padding-left: 0.12rem;
      box-sizing: border-box;
    }
    .list-table-2 {
      width: 75%;
      padding-left: 0.12rem;
      box-sizing: border-box;
      .table-2-1 {
        width: 100%;
        display: flex;
        .list-2-1 {
          width: 100%;
          display: flex;
          .list {
            width: 25%;
            margin: 0.1rem;
            .list-box {
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          .list2 {
            width: 75%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding: 0.1rem 0;
          }
        }
      }
    }
  }
  .role-table-box:nth-child(2n - 2) {
    background-color: #fbfcff;
  }
}
</style>
